<template>
  <kst-page-details
    :actions="actions"
    @init="handleInit"
  >
    <b-tabs multiline v-model="activeTab" size="is-medium" type="is-boxed">
      <b-tab-item :label="tabs.Details">
        <Details :data="data"/>
      </b-tab-item>
    </b-tabs>
  </kst-page-details>
</template>

<script>
import Info from "../ExpInfo.js";
import Model from "../ExpModel.js";
import Services from "../../../services/Api/ExpenseServices.js";

import Details from "./ExpD_Details.vue";

export default {
  components: {
    Details
  },
  data: () => ({
    actions: [],
    data: {},
    // tabs
    activeTab: 0,
    tabs: {
      Details: Info.Tabs.Details
    }
  }),
  methods: {
    /*** by page ***/

    handleInit(id, loadDetails) {
      this.resetData(id);

      const config = Services.getDetailsData(id);
      loadDetails(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      this.data = data.Details;
    },

    /*** custom ***/

    resetData(id) {
      this.data = {};
      this.activeTab = 0;

      // actions
      const access = this.$kst.Access.create(Model.Access);
      const urlParams = this.$kst.Route.getParams({
        [this.$kst.Enum.Param.ID]: id
      });

      this.actions = this.$kst.Access.getAvailableActions(
        Model.Actions.Details, Model.Module, urlParams, access
      );
    }
  }
}
</script>